import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { API_URL } from '../config/api';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');
      const type = searchParams.get('type');

      if (!token) {
        setError('Invalid verification link');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${API_URL}/auth/verify-email?token=${token}&type=${type || 'signup'}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        if (response.ok) {
          // Login user and redirect
          if (data.access_token) {
            try {
              login(data.access_token, data.apiKey);
              navigate('/api-request');
            } catch (error: any) {
              setError(error.message || 'Failed to log in: API key is missing');
              setLoading(false);
            }
          } else {
            setError('Login failed: access token is missing');
            setLoading(false);
          }
        } else {
          setError(data.message || 'Email verification failed');
          setLoading(false);
        }
      } catch (error) {
        setError('Network error. Please try again.');
        setLoading(false);
        console.error('Error:', error);
      }
    };

    verifyEmail();
  }, [searchParams, navigate, login]);

  const containerStyles = {
    minHeight: '100vh',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    padding: '40px 20px',
  };

  if (loading) {
    return (
      <div style={containerStyles}>
        <div style={{ fontSize: '18px', color: '#666' }}>Verifying your email...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={containerStyles}>
        <div style={{ fontSize: '18px', color: '#CF2C20', textAlign: 'center' }}>{error}</div>
      </div>
    );
  }

  return (
    <div style={containerStyles}>
      <div style={{ fontSize: '18px', color: '#666' }}>Redirecting...</div>
    </div>
  );
}

